import publishIconMenu from 'assets/icons/icon-publish-12-negative.svg';
import publishIconBtn from 'assets/icons/icon-publish-12-white.svg';
import { authenticationSelector } from 'modules/authentication';
import { isLegacyFreeUserAtom } from 'modules/authorization';
import { useProposalsByStatusSelector } from 'modules/proposals';
import {
  useOverviewUpgradePlusModalOpen,
  useSetOverviewUpgradePlusModalOpen,
} from 'modules/proposals-overview';
import { Proposal } from 'modules/proposals/Proposal';
import { EmailVerificationModal } from 'modules/settings';
import {
  subscriptionAtoms,
  SubscriptionSelectModal,
  subscriptionSelectors,
} from 'modules/subscription';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useRecoilValue } from 'recoil';
import { Button } from 'shared/components';
import { useModal } from 'shared/hooks';

interface Props {
  className: string;
  isDrawerBtn?: boolean;
}

const isDevelopment = process.env.NODE_ENV === 'development';

export const PublishButton: React.FC<Props> = ({ className, isDrawerBtn }) => {
  const {
    isModalOpen: isEmailVerificationModalOpen,
    closeModal: closeEmailVerificationModal,
    openModal: openEmailVerificationModal,
  } = useModal();
  const { user } = useSelector(authenticationSelector.getState);
  const isTwitterLogin = useSelector(authenticationSelector.isTwitterLogin);
  const isLegacyFreeUser = useRecoilValue(isLegacyFreeUserAtom);
  const { setValue } = useFormContext<PublishStatusAware<Proposal>>();
  const isUpgradePlusModalOpen = useOverviewUpgradePlusModalOpen();
  const setIsPlusUpgradeModalOpen = useSetOverviewUpgradePlusModalOpen();
  const isTierOne = useRecoilValue(subscriptionSelectors.isTierOne);
  const published = useProposalsByStatusSelector('published');
  const hasUsedFreeTrial = useRecoilValue(subscriptionAtoms.hasUsedFreeTrial);

  function handlePublish(event: React.MouseEvent<HTMLButtonElement>) {
    if (!user?.emailVerified && !isTwitterLogin && !isDevelopment) {
      event.preventDefault();
      openEmailVerificationModal();
      return;
    }

    if (hasUsedFreeTrial && !isTierOne && !isLegacyFreeUser) {
      event.preventDefault();
      setIsPlusUpgradeModalOpen(true);
      return;
    }

    if (published?.length >= 3 && !isTierOne) {
      event.preventDefault();
      setIsPlusUpgradeModalOpen(true);
      return;
    }

    setValue('nextPublishStatus', 'published');
  }

  return (
    <>
      <Button
        className={className}
        onClick={handlePublish}
        btnSelector="publish-proposal-btn"
        type="submit"
      >
        {isDrawerBtn ? (
          <img
            src={publishIconMenu}
            alt="PublishIcon"
            className="btn__icon btn__icon__left"
          />
        ) : (
          <img
            src={publishIconBtn}
            alt="PublishIcon"
            className="btn__icon btn__icon__left"
          />
        )}
        <span>
          <FormattedMessage id="buttons.publish" />
        </span>
      </Button>
      {isEmailVerificationModalOpen && (
        <EmailVerificationModal
          email={user?.email || ''}
          onClose={closeEmailVerificationModal}
        />
      )}
      {isUpgradePlusModalOpen && (
        <SubscriptionSelectModal
          onClose={() => setIsPlusUpgradeModalOpen(false)}
        />
      )}
    </>
  );
};
